(function () {
  "use strict";

  // =========================================================
  // CONFIGURATION
  // =========================================================

  var config =
    window.TCG_SET_BROWSER_CONFIG || {};

  var browserConfig = {
    game:
      String(config.game || "").trim(),

    dataUrl:
      String(config.dataUrl || "").trim(),

    thirdView: {
      enabled: Boolean(
        config.thirdView &&
        config.thirdView.enabled
      ),

      label: String(
        (
          config.thirdView &&
          config.thirdView.label
        ) ||
        "Groups"
      ).trim(),

      field: String(
        (
          config.thirdView &&
          config.thirdView.field
        ) ||
        "group_name"
      ).trim()
    },

    icon: {
      type: String(
        (
          config.icon &&
          config.icon.type
        ) ||
        ""
      ).trim(),

      field: String(
        (
          config.icon &&
          config.icon.field
        ) ||
        "set_code"
      ).trim(),

      prefix: String(
        (
          config.icon &&
          config.icon.prefix
        ) ||
        ""
      ).trim(),

      extension: String(
        (
          config.icon &&
          config.icon.extension
        ) ||
        ""
      ).trim(),

      fallback: String(
        (
          config.icon &&
          config.icon.fallback
        ) ||
        ""
      ).trim()
    }
  };

  if (!browserConfig.game) {
    console.error(
      "TCG set browser: game is missing."
    );

    return;
  }

  if (!browserConfig.dataUrl) {
    console.error(
      "TCG set browser: data URL is missing."
    );

    return;
  }

  // =========================================================
  // PAGE ELEMENTS
  // =========================================================

  var browserElement =
    document.querySelector(
      "[data-tcg-set-browser]"
    );

  var tabsElement =
    document.querySelector(
      "[data-tcg-browser-tabs]"
    );

  var statusElement =
    document.querySelector(
      "[data-tcg-browser-status]"
    );

  var navElement =
    document.querySelector(
      "[data-tcg-browser-nav]"
    );

  var sectionsElement =
    document.querySelector(
      "[data-tcg-browser-sections]"
    );

  if (
    !browserElement ||
    !tabsElement ||
    !statusElement ||
    !navElement ||
    !sectionsElement
  ) {
    console.error(
      "TCG set browser: required page elements are missing."
    );

    return;
  }

  // =========================================================
  // STATE
  // =========================================================

  var allSets = [];
  var currentView = "alphabet";

  // =========================================================
  // DATA NORMALIZATION
  // =========================================================

  function parseReleaseDate(value) {
    var text =
        String(value || "").trim();

    var result = {
        year: 0,
        month: 0,
        day: 0
    };

    if (!text) {
        return result;
    }

    var match;

    // YYYY-MM-DD
    match =
        text.match(
        /^(\d{4})-(\d{1,2})-(\d{1,2})$/
        );

    if (match) {
        result.year = Number(match[1]);
        result.month = Number(match[2]);
        result.day = Number(match[3]);

        return result;
    }

    // MM.DD.YYYY
    match =
        text.match(
        /^(\d{1,2})\.(\d{1,2})\.(\d{4})$/
        );

    if (match) {
        result.month = Number(match[1]);
        result.day = Number(match[2]);
        result.year = Number(match[3]);

        return result;
    }

    // MM/DD/YYYY
    match =
        text.match(
        /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/
        );

    if (match) {
        result.month = Number(match[1]);
        result.day = Number(match[2]);
        result.year = Number(match[3]);

        return result;
    }

    return result;
    }

  function normalizeSet(set) {
    set = set || {};

    var name =
      String(
        set.name ||
        set.title ||
        set.collection_name ||
        ""
      ).trim();

    var sortName =
      String(
        set.sort_name ||
        set.sortName ||
        name
      ).trim();

    var handle =
      String(
        set.handle ||
        set.collection_handle ||
        ""
      ).trim();

    var url =
      String(
        set.url ||
        set.collection_url ||
        ""
      ).trim();

    if (!url && handle) {
      url =
        "/collections/" +
        encodeURIComponent(handle);
    }

    var releaseDate =
    String(
        set.release_date ||
        set.releaseDate ||
        set.date ||
        ""
    ).trim();

    var parsedReleaseDate =
    parseReleaseDate(releaseDate);

    var releaseYear =
    Number(
        set.release_year ||
        set.releaseYear ||
        parsedReleaseDate.year ||
        0
    );

    var groupName =
      String(
        set[
          browserConfig.thirdView.field
        ] ||
        set.group_name ||
        set.groupName ||
        ""
      ).trim();

    var productCount =
      Number(
        set.product_count ||
        set.productCount ||
        set.count ||
        0
      );

    return {
      name: name,
      sortName: sortName,
      url: url,

      setCode: String(
        set.set_code ||
        set.setCode ||
        ""
      ).trim(),

      iconCode: String(
        set.icon_code ||
        set.iconCode ||
        set.set_code ||
        set.setCode ||
        ""
      ).trim(),

      releaseDate: releaseDate,
      releaseYear: releaseYear,
      groupName: groupName,
      productCount: productCount
    };
  }

  function normalizeData(data) {
    var rawSets = [];

    if (Array.isArray(data)) {
      rawSets = data;
    } else if (
      data &&
      Array.isArray(data.sets)
    ) {
      rawSets = data.sets;
    } else if (
      data &&
      Array.isArray(data.collections)
    ) {
      rawSets = data.collections;
    } else if (
      data &&
      Array.isArray(data.data)
    ) {
      rawSets = data.data;
    }

    return rawSets
      .map(normalizeSet)
      .filter(function (set) {
        return Boolean(
          set.name &&
          set.url
        );
      });
  }

  // =========================================================
  // SORTING
  // =========================================================

  function compareNames(a, b) {
    return a.sortName.localeCompare(
      b.sortName,
      undefined,
      {
        sensitivity: "base",
        numeric: true
      }
    );
  }

  function compareReleaseDates(a, b) {
    var dateA =
      a.releaseDate || "";

    var dateB =
      b.releaseDate || "";

    if (dateA !== dateB) {
      return dateB.localeCompare(dateA);
    }

    return compareNames(a, b);
  }

  // =========================================================
  // GROUPING
  // =========================================================

  function getAlphabetKey(set) {
    var firstCharacter =
      set.sortName
        .charAt(0)
        .toUpperCase();

    if (
      /^[A-Z]$/.test(firstCharacter)
    ) {
      return firstCharacter;
    }

    return "#";
  }

  function groupSetsAlphabetically(sets) {
    var groups = {};

    sets
      .slice()
      .sort(compareNames)
      .forEach(function (set) {
        var key =
          getAlphabetKey(set);

        if (!groups[key]) {
          groups[key] = [];
        }

        groups[key].push(set);
      });

    return groups;
  }

  function groupSetsByYear(sets) {
    var groups = {};

    sets
      .slice()
      .sort(compareReleaseDates)
      .forEach(function (set) {
        var key =
          set.releaseYear
            ? String(set.releaseYear)
            : "Unknown";

        if (!groups[key]) {
          groups[key] = [];
        }

        groups[key].push(set);
      });

    return groups;
  }

  function groupSetsByThirdView(sets) {
    var groups = {};

    sets
      .slice()
      .sort(compareNames)
      .forEach(function (set) {
        var key =
          set.groupName ||
          "Other";

        if (!groups[key]) {
          groups[key] = [];
        }

        groups[key].push(set);
      });

    return groups;
  }

  function getGroupedSets(view) {
    if (view === "years") {
      return groupSetsByYear(allSets);
    }

    if (view === "groups") {
      return groupSetsByThirdView(
        allSets
      );
    }

    return groupSetsAlphabetically(
      allSets
    );
  }

  function getGroupKeys(view, groups) {
    var keys =
      Object.keys(groups);

    if (view === "alphabet") {
      var alphabet =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

      var ordered = [];

      if (groups["#"]) {
        ordered.push("#");
      }

      alphabet.forEach(function (letter) {
        if (groups[letter]) {
          ordered.push(letter);
        }
      });

      return ordered;
    }

    if (view === "years") {
      return keys.sort(function (a, b) {
        if (a === "Unknown") {
          return 1;
        }

        if (b === "Unknown") {
          return -1;
        }

        return Number(b) - Number(a);
      });
    }

    return keys.sort(function (a, b) {
      if (a === "Other") {
        return 1;
      }

      if (b === "Other") {
        return -1;
      }

      return a.localeCompare(
        b,
        undefined,
        {
          sensitivity: "base",
          numeric: true
        }
      );
    });
  }

  // =========================================================
  // TEXT HELPERS
  // =========================================================

  function formatReleaseDate(value) {
    var parsed =
        parseReleaseDate(value);

    if (
        !parsed.year ||
        !parsed.month
    ) {
        return value || "";
    }

    var date =
        new Date(
        parsed.year,
        parsed.month - 1,
        1
        );

    if (
        Number.isNaN(date.getTime())
    ) {
        return value || "";
    }

    return date.toLocaleDateString(
        "en-US",
        {
        month: "short",
        year: "numeric"
        }
    );
    }

  function formatProductCount(count) {
    if (!count || count < 1) {
      return "";
    }

    return (
      count.toLocaleString("en-US") +
      (
        count === 1
          ? " card"
          : " cards"
      )
    );
  }

  function createSectionId(view, key) {
    return (
      "tcg-" +
      view +
      "-" +
      String(key)
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "")
    );
  }

  // =========================================================
  // SET ROW RENDERING
  // =========================================================

  function createSetIcon(set) {
    var symbol =
      document.createElement("span");

    symbol.className =
      "tcg-set-browser-symbol";

    symbol.setAttribute(
      "aria-hidden",
      "true"
    );

        /*
      Set code text

      Used for games without set symbols,
      such as One Piece, Lorcana,
      Gundam, and Riftbound.
    */

    if (
      browserConfig.icon.type ===
        "code" &&
      set.setCode
    ) {
      var code =
        document.createElement("span");

      code.className =
        "tcg-set-browser-code";

      code.textContent =
        set.setCode.toUpperCase();

      symbol.appendChild(code);

      return symbol;
    }

    /*
      Magic: Keyrune
    */

    if (
      browserConfig.icon.type ===
        "keyrune" &&
      set.iconCode
    ) {
      var keyruneIcon =
        document.createElement("i");

      keyruneIcon.className =
        "ss ss-" +
        set.iconCode.toLowerCase();

      symbol.appendChild(
        keyruneIcon
      );

      return symbol;
    }


    /*
      Pokémon: Shopify image asset

      Example:
      iconCode = me4

      becomes:
      pokemon-set-me4.png
    */

    if (
      browserConfig.icon.type ===
        "asset" &&
      set.iconCode
    ) {
      var filename =
        browserConfig.icon.prefix +
        set.iconCode.toLowerCase() +
        browserConfig.icon.extension;

      try {
        /*
          pokemon-sets.json is already being loaded
          from Shopify Assets.

          We use that URL as the base and replace
          pokemon-sets.json with the symbol filename.
        */

        var imageUrl =
          new URL(
            browserConfig.dataUrl,
            window.location.href
          );

        var pathParts =
          imageUrl.pathname.split("/");

        pathParts[
          pathParts.length - 1
        ] = filename;

        imageUrl.pathname =
          pathParts.join("/");

        /*
          Remove the JSON file's cache/version query
          before loading the different asset.
        */
        imageUrl.search = "";

        var image =
          document.createElement("img");

        image.className =
          "tcg-set-browser-symbol-image";

        image.src =
          imageUrl.toString();

        image.alt = "";

        image.loading =
          "lazy";

        image.decoding =
          "async";


        /*
          If Shopify cannot find the requested image,
          show the Poké Ball instead.
        */
        image.addEventListener(
          "error",
          function () {
            image.remove();

            if (
              browserConfig.icon.fallback ===
              "pokeball"
            ) {
              var pokeball =
                document.createElement("span");

              pokeball.className =
                "tcg-pokeball-icon";

              symbol.appendChild(
                pokeball
              );
            }
          },
          {
            once: true
          }
        );

        symbol.appendChild(
          image
        );

        return symbol;

      } catch (error) {
        /*
          Fall through to the Poké Ball below.
        */
      }
    }


    /*
      Pokémon Poké Ball fallback
    */

    if (
      browserConfig.icon.type ===
        "pokeball" ||
      browserConfig.icon.fallback ===
        "pokeball"
    ) {
      var pokeball =
        document.createElement("span");

      pokeball.className =
        "tcg-pokeball-icon";

      symbol.appendChild(
        pokeball
      );

      return symbol;
    }


    /*
      Generic fallback for future games
    */

    var fallback =
      document.createElement("span");

    fallback.className =
      "tcg-set-icon-fallback";

    fallback.textContent = "◆";

    symbol.appendChild(
      fallback
    );

    return symbol;
  }

  function createSetRow(set) {
    var link =
      document.createElement("a");

    link.className =
      "tcg-set-browser-row";

    link.href = set.url;

    var symbol =
      createSetIcon(set);

    var info =
      document.createElement("span");

    info.className =
      "tcg-set-browser-info";

    var name =
      document.createElement("span");

    name.className =
      "tcg-set-browser-name";

    name.textContent =
      set.name;

    info.appendChild(name);

    var metaParts = [];

    if (
      set.setCode &&
      browserConfig.icon.type !==
        "code"
    ) {
      metaParts.push(
        set.setCode.toUpperCase()
      );
    }

    var formattedDate =
      formatReleaseDate(
        set.releaseDate
      );

    if (formattedDate) {
      metaParts.push(formattedDate);
    } else if (set.releaseYear) {
      metaParts.push(
        String(set.releaseYear)
      );
    }

    var formattedCount =
      formatProductCount(
        set.productCount
      );

    if (formattedCount) {
      metaParts.push(formattedCount);
    }

    if (metaParts.length) {
      var meta =
        document.createElement("span");

      meta.className =
        "tcg-set-browser-meta";

      metaParts.forEach(function (
        part,
        index
      ) {
        var piece =
          document.createElement("span");

        piece.textContent = part;

        if (
          part === formattedDate
        ) {
          piece.className =
            "tcg-set-browser-date";
        }

        if (
          part === formattedCount
        ) {
          piece.className =
            "tcg-set-browser-count";
        }

        if (index > 0) {
          meta.appendChild(
            document.createTextNode(
              " • "
            )
          );
        }

        meta.appendChild(piece);
      });

      info.appendChild(meta);
    }

    link.appendChild(symbol);
    link.appendChild(info);

    return link;
  }

  // =========================================================
  // SECTION RENDERING
  // =========================================================

  function createSection(
    view,
    key,
    sets
  ) {
    var section =
      document.createElement("section");

    section.className =
      "tcg-set-browser-section";

    section.id =
      createSectionId(view, key);

    section.setAttribute(
      "data-tcg-browser-section",
      key
    );

    var heading =
      document.createElement("h3");

    heading.textContent = key;

    var list =
      document.createElement("div");

    list.className =
      "tcg-set-browser-list";

    sets.forEach(function (set) {
      list.appendChild(
        createSetRow(set)
      );
    });

    section.appendChild(heading);
    section.appendChild(list);

    return section;
  }

  function renderSections(
    view,
    groups,
    keys
  ) {
    sectionsElement.innerHTML = "";

    var fragment =
      document.createDocumentFragment();

    keys.forEach(function (key) {
      fragment.appendChild(
        createSection(
          view,
          key,
          groups[key]
        )
      );
    });

    sectionsElement.appendChild(
      fragment
    );
  }

  // =========================================================
  // NAVIGATION RENDERING
  // =========================================================

  function createNavLink(
    view,
    key,
    label
  ) {
    var link =
      document.createElement("a");

    link.href =
      "#" +
      createSectionId(view, key);

    link.textContent = label;

    link.setAttribute(
      "data-tcg-nav-link",
      key
    );

    link.addEventListener(
      "click",
      function (event) {
        event.preventDefault();

        var section =
          document.getElementById(
            createSectionId(
              view,
              key
            )
          );

        if (!section) {
          return;
        }

        setActiveNavLink(link);

        section.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }
    );

    return link;
  }

  function createDisabledLetter(
    label
  ) {
    var disabled =
      document.createElement("span");

    disabled.className =
      "tcg-set-browser-nav-disabled";

    disabled.textContent = label;

    disabled.setAttribute(
      "aria-disabled",
      "true"
    );

    return disabled;
  }

  function renderAlphabetNav(groups) {
    var alphabet =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

    if (groups["#"]) {
    navElement.appendChild(
        createNavLink(
        "alphabet",
        "#",
        "#"
        )
    );
    } else {
    navElement.appendChild(
        createDisabledLetter("#")
    );
    }

    alphabet.forEach(function (letter) {
      if (groups[letter]) {
        navElement.appendChild(
          createNavLink(
            "alphabet",
            letter,
            letter
          )
        );
      } else {
        navElement.appendChild(
          createDisabledLetter(letter)
        );
      }
    });
  }

  function renderStandardNav(
    view,
    keys
  ) {
    keys.forEach(function (key) {
      navElement.appendChild(
        createNavLink(
          view,
          key,
          key
        )
      );
    });
  }

  function renderNavigation(
    view,
    groups,
    keys
  ) {
    navElement.innerHTML = "";

    if (view === "alphabet") {
      renderAlphabetNav(groups);
    } else {
      renderStandardNav(
        view,
        keys
      );
    }

    navElement.hidden =
      keys.length === 0;
  }

  function setActiveNavLink(
    activeLink
  ) {
    var links =
      navElement.querySelectorAll(
        "[data-tcg-nav-link]"
      );

    links.forEach(function (link) {
      link.classList.toggle(
        "active",
        link === activeLink
      );
    });
  }

  // =========================================================
  // VIEW RENDERING
  // =========================================================

  function renderView(view) {
    currentView = view;

    var groups =
      getGroupedSets(view);

    var keys =
      getGroupKeys(
        view,
        groups
      );

    renderNavigation(
      view,
      groups,
      keys
    );

    renderSections(
      view,
      groups,
      keys
    );

    if (keys.length) {
      statusElement.hidden = true;
    } else {
      statusElement.hidden = false;
      statusElement.textContent =
        "No sets were found for this view.";
    }
  }

  // =========================================================
  // TAB HANDLING
  // =========================================================

  function setActiveTab(
    activeButton
  ) {
    var buttons =
      tabsElement.querySelectorAll(
        "[data-tcg-view]"
      );

    buttons.forEach(function (button) {
      var isActive =
        button === activeButton;

      button.classList.toggle(
        "active",
        isActive
      );

      button.setAttribute(
        "aria-pressed",
        isActive
          ? "true"
          : "false"
      );
    });
  }

  function initializeTabs() {
    var buttons =
      tabsElement.querySelectorAll(
        "[data-tcg-view]"
      );

    buttons.forEach(function (button) {
      button.addEventListener(
        "click",
        function () {
          var view =
            button.getAttribute(
              "data-tcg-view"
            );

          if (!view) {
            return;
          }

          if (
            view === "groups" &&
            !browserConfig.thirdView.enabled
          ) {
            return;
          }

          setActiveTab(button);
          renderView(view);
        }
      );
    });
  }

  // =========================================================
  // THIRD VIEW
  // =========================================================

  function configureThirdView() {
    var button =
      tabsElement.querySelector(
        "[data-tcg-third-view]"
      );

    if (!button) {
      return;
    }

    var hasGroupData =
      allSets.some(function (set) {
        return Boolean(
          set.groupName
        );
      });

    var shouldShow =
      browserConfig.thirdView.enabled &&
      hasGroupData;

    button.hidden =
      !shouldShow;

    if (shouldShow) {
      button.textContent =
        browserConfig.thirdView.label;
    }
  }

  // =========================================================
  // DATA LOADING
  // =========================================================

  function showLoading() {
    statusElement.hidden = false;
    statusElement.textContent =
      "Loading sets...";

    navElement.hidden = true;
    sectionsElement.innerHTML = "";
  }

  function showError(message) {
    statusElement.hidden = false;
    statusElement.textContent =
      message;

    navElement.hidden = true;
    sectionsElement.innerHTML = "";
  }

  function loadSets() {
    showLoading();

    fetch(
      browserConfig.dataUrl,
      {
        credentials: "same-origin",
        cache: "no-store"
      }
    )
      .then(function (response) {
        if (!response.ok) {
          throw new Error(
            "HTTP " +
            response.status
          );
        }

        return response.json();
      })
      .then(function (data) {
        allSets =
          normalizeData(data);

        if (!allSets.length) {
          throw new Error(
            "The JSON file did not contain any usable sets."
          );
        }

        configureThirdView();
        renderView(currentView);
      })
      .catch(function (error) {
        console.error(
          "TCG set browser failed to load:",
          error
        );

        showError(
          "The set list could not be loaded. Please refresh the page and try again."
        );
      });
  }

  // =========================================================
  // STARTUP
  // =========================================================

  initializeTabs();
  loadSets();

})();